/* ============================================================
   AVORA HOME — Product Delivery Estimate (live)
   Renders the shopper's destination flag, a live estimated
   arrival window, the most-probable arrival date, and a
   per-second "order within" countdown to the daily cut-off.

   ▸ EDIT THESE VALUES to change the promise — nothing else needs to change:
       cutoffHour  — order before this local hour (24h clock) for the earlier window
       minDays     — earliest estimated arrival, in BUSINESS days
       likelyDays  — most-probable / average arrival, in BUSINESS days
       maxDays     — latest estimated arrival, in BUSINESS days
   ============================================================ */
(function () {
  'use strict';

  var CONFIG = {
    cutoffHour: 21,      // 9:00 PM, visitor's local time
    minDays:    5,       // headline window start (business days)
    likelyDays: 6,       // "most orders arrive by" (business days)
    maxDays:    8,       // headline window end (business days)
    locale:     'en-GB'  // date wording, e.g. "Mon, 1 Jul"
  };

  /* ISO 3166-1 alpha-2 → emoji flag (regional indicator symbols). */
  function isoToFlag(code) {
    if (!code || code.length !== 2) return '';
    var offset = 0x1F1E6 - 65; // 'A' = 65
    return String.fromCodePoint(code.codePointAt(0) + offset) +
           String.fromCodePoint(code.codePointAt(1) + offset);
  }

  function isBusinessDay(d) {
    var day = d.getDay();
    return day !== 0 && day !== 6; // skip Sun (0) + Sat (6)
  }

  /* Returns a new Date n business days after `start` (start excluded). */
  function addBusinessDays(start, n) {
    var d = new Date(start);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString(CONFIG.locale, { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init() {
    var root = document.querySelector('.avora-delivery');
    if (!root) return;

    /* ----- Destination country + flag ----- */
    var code = (root.getAttribute('data-country-code') || '').toUpperCase();
    var name = root.getAttribute('data-country-name') || '';
    var flagEl = root.querySelector('.avora-delivery__flag');
    var nameEl = root.querySelector('.avora-delivery__country-name');
    if (flagEl) {
      var flag = isoToFlag(code);
      if (flag) flagEl.textContent = flag;
    }
    if (nameEl) nameEl.textContent = name || 'your location';

    /* ----- "Change" opens the header country selector (desktop only) ----- */
    var changeBtn = root.querySelector('.avora-delivery__change');
    var csTrigger = document.querySelector('.cs__trigger');
    if (changeBtn && csTrigger && csTrigger.offsetParent !== null) {
      changeBtn.hidden = false;
      changeBtn.addEventListener('click', function () {
        var cs = document.querySelector('.cs');
        if (cs && cs.scrollIntoView) cs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { csTrigger.click(); }, 350);
      });
    }

    /* ----- Live arrival window + countdown ----- */
    var datesEl = root.querySelector('[data-delivery-dates]');
    var likelyEl = root.querySelector('[data-delivery-likely-date]');
    var timerEl = root.querySelector('[data-delivery-timer]');
    var countdownEl = root.querySelector('[data-delivery-countdown]');
    if (countdownEl) countdownEl.hidden = false;

    function tick() {
      var now = new Date();
      var cutoff = new Date();
      cutoff.setHours(CONFIG.cutoffHour, 0, 0, 0);

      // Dispatch base: today if before the cut-off, otherwise the next day.
      var start = new Date(now);
      if (now.getTime() >= cutoff.getTime()) {
        cutoff.setDate(cutoff.getDate() + 1);
        start.setDate(start.getDate() + 1);
      }
      // Never start the clock on a weekend.
      while (!isBusinessDay(start)) start.setDate(start.getDate() + 1);

      var lo = addBusinessDays(start, CONFIG.minDays);
      var likely = addBusinessDays(start, CONFIG.likelyDays);
      var hi = addBusinessDays(start, CONFIG.maxDays);

      if (datesEl) datesEl.textContent = formatDate(lo) + ' – ' + formatDate(hi);
      if (likelyEl) likelyEl.textContent = formatDate(likely);

      var diff = Math.max(0, cutoff.getTime() - now.getTime());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (timerEl) timerEl.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
